import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@chakra-ui/react';
import { CIL, STICKY_CTA_LABEL } from './constants';

const StickyCTA = ({ onIscriviti, isRegistrationOpen = true, userData }) => {
  if (!isRegistrationOpen) return null;
  return (
    <Box
      position="fixed"
      bottom={0}
      left={0}
      right={0}
      w="100%"
      bg={CIL.plum}
      p={4}
      display={{ base: 'block', md: 'none' }}
      zIndex={1000}
      boxShadow="0 -2px 8px rgba(0,0,0,0.1)"
    >
      {userData ? (
        <Button
          w="100%"
          bg={CIL.yellow}
          color={CIL.plum}
          size="lg"
          minH="56px"
          fontWeight="bold"
          fontSize="xl"
          borderRadius="8px"
          boxShadow="0 -2px 12px rgba(0,0,0,0.2)"
          _hover={{ bg: 'white', color: CIL.plum }}
          onClick={onIscriviti}
        >
          {STICKY_CTA_LABEL}
        </Button>
      ) : (
        <Button
          as={Link}
          to="/tesseramento"
          w="100%"
          bg={CIL.yellow}
          color={CIL.plum}
          size="lg"
          minH="56px"
          fontWeight="bold"
          fontSize="xl"
          borderRadius="8px"
          boxShadow="0 -2px 12px rgba(0,0,0,0.2)"
          _hover={{ bg: 'white', color: CIL.plum }}
        >
          Diventa socio
        </Button>
      )}
    </Box>
  );
};

export default StickyCTA;
